import CashCollectionReport from './CashCollectionReport.redux';

export default CashCollectionReport;
